import Vue from 'vue'

/**
 * Registro reativo dos conteúdos teleportados, por nome de destino, COM POSSE.
 *
 * Vários `<Teleport to="x">` (de views diferentes — ex: o filtro de cada rota do
 * CRM) podem mirar o MESMO destino "x". Para garantir UNICIDADE na troca de rota,
 * cada destino tem um DONO: o último `<Teleport>` a MONTAR (`claim`) assume a
 * posse. Um Teleport que está saindo (`update` no `updated` / `release` no
 * `beforeDestroy`) só mexe no destino se AINDA for o dono — assim um view sendo
 * desmontado NUNCA sobrescreve nem apaga o conteúdo de um view que já assumiu o
 * destino. (Era o bug: relationship mostrando o filtro de leads ao voltar.)
 *
 * Por ser uma instância Vue, `targets` é reativo: claim/update/release disparam o
 * re-render do(s) target(s) que dependem daquela chave.
 */
export const TeleportBus = new Vue({
  data() {
    return {
      // { [nome do destino]: VNode[] } — conteúdo do dono atual
      targets: {},
      // { [nome do destino]: ownerId } — quem é o dono ativo do destino
      owners: {},
    }
  },
  methods: {
    // Mount: assume a posse do destino (último a montar vence).
    claim(name, ownerId, vnodes) {
      this.$set(this.owners, name, ownerId)
      this.$set(this.targets, name, vnodes || [])
    },
    // Updated: só atualiza o conteúdo se AINDA for o dono.
    update(name, ownerId, vnodes) {
      if (this.owners[name] === ownerId) {
        this.$set(this.targets, name, vnodes || [])
      }
    },
    // beforeDestroy: só libera se AINDA for o dono (não apaga conteúdo de um
    // view mais novo que já assumiu o mesmo destino).
    release(name, ownerId) {
      if (this.owners[name] === ownerId) {
        this.$delete(this.owners, name)
        this.$delete(this.targets, name)
      }
    },
    // Setters diretos (sem posse) — uso em testes/casos simples.
    publish(name, vnodes) {
      this.$set(this.targets, name, vnodes || [])
    },
    remove(name) {
      this.$delete(this.targets, name)
      this.$delete(this.owners, name)
    },
  },
})

export default TeleportBus
